import { InjectionToken } from '@angular/core'

export const FIREBASE_SETTINGS  = new InjectionToken<Object>('FIREBASE_SETTINGS')
